import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { reducers } from '@adc/ui-morpheus'
import {
  CLIENTS,
  CLIENTS_ROLES,
  ENDPOINTS,
  USERS,
  MAX_BID_CHANGES,
  PARTY_ROLE_CHANGES,
  TINY_URLS,
  USER_CHANGES,
  USER_REGISTERED_LISTINGS,
  USER_LISTINGS_BANNED_FROM_BIDDING,
  MORPHEUS_LOGS,
  ORGANIZATION,
  ORGANIZATION_MEMBERS,
  TRANSACTIONS,
  COMMUNICATIONS,
  ORGANIZATION_CHANGES,
  EVENTS,
  EVENT_CHANGES,
  VENUES,
  EVENT_TEMPLATES,
  VENUE_TEMPLATES,
  VENUE_TEMPLATE_CHANGES,
  EVENT_TEMPLATES_FORM,
  EVENT_FORM_EVENT_TEMPLATES,
  EVENT_FORM_VENUE_TEMPLATES,
  VENUE_CHANGES,
} from '../constants/tableTypes'
import clients from './clients'
import clientsRoles from './clientsRoles'
import endpoints from './endpoints'
import users from './users'
import transactions from './transactions'
import audit from './auditPage'
import organizationAudit from './organizationAuditPage'
import partyRoleHistory from './partyRoleHistory'
import maxBidHistory from './maxBidHistory'
import userHistory from './userHistory'
import organizationHistory from './organizationHistory'
import roles from './roles'
import partyRoles from './partyRoles'
import tinyUrls from './tinyUrls'
import userRegisteredListings from './userRegisteredListings'
import userListingsBannedFromBidding from './userListingsBannedFromBidding'
import finance from './finance'
import userWallet from './userWallet'
import morpheusLogsReducer from './morpheusLogs'
import savedSearchesReducer from './savedSearches'
import organization from './organization'
import organizationMembers from './organizationMembers'
import communications from './communications'
import venueTemplates from './venueTemplates'
import venueTemplateHistory from './venueTemplateHistory'
import venues from './venues'
import eventTemplates from './eventTemplates'
import events from './events'
import eventHistory from './eventHistory'
import venueHistory from './venueHistory'
import { eventFormEventTemplates, eventFormVenueTemplates } from './eventForm'
import eventTemplateForm from './eventTemplateForm'

export default combineReducers({
  audit,
  organizationAudit,
  user: reducers.user.userReducer,
  featureFlags: reducers.featureFlags.featureFlagReducer,
  [CLIENTS]: clients,
  [CLIENTS_ROLES]: clientsRoles,
  [ENDPOINTS]: endpoints,
  [TRANSACTIONS]: transactions,
  [USERS]: users,
  [PARTY_ROLE_CHANGES]: partyRoleHistory,
  [MAX_BID_CHANGES]: maxBidHistory,
  [TINY_URLS]: tinyUrls,
  [USER_CHANGES]: userHistory,
  [ORGANIZATION_CHANGES]: organizationHistory,
  [USER_REGISTERED_LISTINGS]: userRegisteredListings,
  [USER_LISTINGS_BANNED_FROM_BIDDING]: userListingsBannedFromBidding,
  [MORPHEUS_LOGS]: morpheusLogsReducer,
  [ORGANIZATION]: organization,
  [ORGANIZATION_MEMBERS]: organizationMembers,
  [COMMUNICATIONS]: communications,
  [VENUE_TEMPLATES]: venueTemplates,
  [VENUE_TEMPLATE_CHANGES]: venueTemplateHistory,
  [EVENTS]: events,
  [EVENT_CHANGES]: eventHistory,
  [VENUES]: venues,
  [EVENT_TEMPLATES]: eventTemplates,
  [EVENT_TEMPLATES_FORM]: eventTemplateForm,
  [EVENT_FORM_EVENT_TEMPLATES]: eventFormEventTemplates,
  [EVENT_FORM_VENUE_TEMPLATES]: eventFormVenueTemplates,
  [VENUE_CHANGES]: venueHistory,
  roles,
  partyRoles,
  form: formReducer,
  finance,
  userWallet,
  savedSearches: savedSearchesReducer,
})
